import React from 'react';
import { Card, CardContent } from './ui/card';
import { mockData } from '../utils/mockData';

const Menu = () => {
  return (
    <section id="menu" className="py-20 bg-stone-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 text-slate-800">O Nosso Menu</h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Peixe fresco grelhado na perfeição sobre carvão, servido com acompanhamentos tradicionais portugueses
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {mockData.menuCategories.map((category, idx) => (
              <Card key={idx} className="border-stone-200 hover:shadow-lg transition-shadow">
                <CardContent className="p-8">
                  <h3 className="text-2xl font-bold mb-6 text-slate-800 border-b border-stone-200 pb-3">
                    {category.name}
                  </h3>
                  <div className="space-y-5">
                    {category.items.map((item, itemIdx) => (
                      <div key={itemIdx} className="group">
                        <h4 className="font-semibold text-lg text-slate-800 group-hover:text-blue-600 transition-colors">
                          {item.name}
                        </h4>
                        {item.description && (
                          <p className="text-slate-600 text-sm mt-1 leading-relaxed">
                            {item.description}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Card className="border-stone-200 max-w-2xl mx-auto bg-blue-50">
              <CardContent className="p-8">
                <h3 className="text-xl font-bold mb-3 text-slate-800">Seleção Fresca Diária</h3>
                <p className="text-slate-700 leading-relaxed">
                  O nosso menu muda de acordo com a captura diária dos pescadores locais. 
                  Visite-nos para ver a seleção de peixe fresco de hoje exibida à entrada.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;
